import {
    GetPipelineOptions,
    GetLabelOptions,
    GetRoleOptions,
    GetSkillOptions,
    GetActivityTypeOptions,
    GetPlaceOptions,
    GetOfficeOptions,
    GetCrmUserOptions,
    GetBossGroupOptions,
} from '../requests/OptionsRequests';

let errorOption = '';

export const fetchAllSelectOptions = async (dispatch) => {
    let allSucceded = true;
    dispatch({ type: 'STARTING_OPTIONS_FETCH' });
    const optionResults = await Promise.all([
        updatePipelineOptions(dispatch),
        updateLabelOptions(dispatch),
        updateRoleOptions(dispatch),
        updateSkillOptions(dispatch),
        updateActivityTypeOptions(dispatch),
        updatePlaceOptions(dispatch),
        updateCrmUserOptions(dispatch),
        updateOfficeOptions(dispatch),
        updateBossGroupOptions(dispatch),
    ]);
    optionResults.forEach((response) => {
        if (!response.success) {
            allSucceded = false;
        }
    });
    if (allSucceded) {
        dispatch({ type: 'FINISHED_OPTIONS_FETCH' });
    } else {
        dispatch({ type: 'STOP_OPTIONS_FETCH' });
        alert(
            'Viktig data kunde inte hämtas. Du borde uppdatera sida för att den ska fungera som den ska. Kontakta alltid@consid.se om problemet återkommer.\n' +
                errorOption
        );
        errorOption = '';
    }
};

const updatePipelineOptions = async (dispatch) => {
    const response = await GetPipelineOptions();
    if (response.success) {
        dispatch({
            type: 'UPDATE_PIPELINE_OPTIONS',
            payload: response.data,
        });
    } else {
        errorOption += 'Kunde inte hämta Pipeline.\n';
    }
    return response;
};

const updateLabelOptions = async (dispatch) => {
    const response = await GetLabelOptions();

    if (response.success) {
        dispatch({
            type: 'UPDATE_LABEL_OPTIONS',
            payload: response.data,
        });
    } else {
        errorOption += 'Kunde inte hämta Label. \n';
    }
    return response;
};

const updateRoleOptions = async (dispatch) => {
    const response = await GetRoleOptions();
    if (response.success) {
        dispatch({
            type: 'UPDATE_ROLE_OPTIONS',
            payload: response.data,
        });
    } else {
        errorOption += 'Kunde inte hämta Options. \n';
    }
    return response;
};

const updateSkillOptions = async (dispatch) => {
    const response = await GetSkillOptions();

    if (response.success) {
        dispatch({
            type: 'UPDATE_SKILL_OPTIONS',
            payload: response.data,
        });
    } else {
        errorOption += 'Kunde inte hämta Skills. \n';
    }
    return response;
};

const updateActivityTypeOptions = async (dispatch) => {
    const response = await GetActivityTypeOptions();

    if (response.success) {
        dispatch({
            type: 'UPDATE_ACTIVITY_TYPE_OPTIONS',
            payload: response.data,
        });
    } else {
        errorOption += 'Kunde inte hämta Aktivitetstyp. \n';
    }
    return response;
};

const updatePlaceOptions = async (dispatch) => {
    const response = await GetPlaceOptions();

    if (response.success) {
        dispatch({
            type: 'UPDATE_PLACE_OPTIONS',
            payload: response.data,
        });
    } else {
        errorOption += 'Kunde inte hämta place.\n';
    }
    return response;
};

const updateOfficeOptions = async (dispatch) => {
    const response = await GetOfficeOptions();

    if (response.success) {
        dispatch({
            type: 'UPDATE_OFFICE_OPTIONS',
            payload: response.data,
        });
    } else {
        errorOption += 'Kunde inte hämta officeOptions.\n';
    }
    return response;
};

const updateCrmUserOptions = async (dispatch) => {
    const response = await GetCrmUserOptions();

    if (response.success) {
        dispatch({
            type: 'UPDATE_CRM_USER_OPTIONS',
            payload: response.data,
        });
    } else {
        errorOption += 'Kunde inte hämta crmUserOptions.\n';
    }
    return response;
};

const updateBossGroupOptions = async (dispatch) => {
    const response = await GetBossGroupOptions();

    response.data = response.data.map((item) =>  {
        return{
            id: item.coaEmpId,
            name: item.name,
            users: item.users,
        }
    })

    if (response.success) {
        dispatch({
            type: 'UPDATE_BOSS_GROUP_OPTIONS',
            payload: response.data,
        });
    } else {
        errorOption += 'Kunde inte hämta bossUserGroups.\n';
    }
    return response;
};
